module.exports = __webpack_public_path__ + "img/product_01.9b170c91.png";